import classnames from 'classnames'
import React, { forwardRef, ReactNode, Ref } from 'react'

export enum CONTAINER_STYLE {
  CENTER_MIDDLE = 'container--cm',
  CENTER_MIDDLE_3 = 'container--cm3',
  CENTER_MIDDLE_4 = 'container--cm4',
  CENTER_MIDDLE_5 = 'container--cm5',
  ACCOUNT = 'container--acc',
  ACCOUNT_2 = 'container--acc2',
  NO_MARGIN = 'container--no-margin',
  REFERRAL_TERMS = 'container--no-margin terms',
  CARD = 'container--card',
  CARD_2 = 'container--card2',
  DEFAULT = '',
}

interface IMainContainerProps {
  children: ReactNode
  style: CONTAINER_STYLE
  button?: ReactNode
}

export const MainContainer = forwardRef((props: IMainContainerProps, ref: Ref<HTMLElement>) => {
  const containerClassNames = classnames('container', props.style)

  return (
    <main ref={ref} className={containerClassNames}>
      {props.children}
      {props.button ?? null}
    </main>
  )
})
